import flatpickr from "flatpickr";
import "select2";

export default function clientReportForm(el, props) {
  let $el = $(el);

  const periodStart = el.querySelector(".flatpickr-period-start");
  const periodEnd = el.querySelector(".flatpickr-period-end");

  let select2MediaTiers = $el.find(".select2-multi-media-tiers");
  select2MediaTiers.select2({
    allowClear: true,
    placeholder: "Select optional media tiers",
  });

  let initialSelectedMediaTierIds = (props.selected_media_tier_ids || []).map(
    function (id) {
      return String(id);
    },
  );

  let periodStartInstance = flatpickr(periodStart, {
    altInput: true,
    altFormat: "J F Y",
  });

  let periodEndInstance = flatpickr(periodEnd, {
    altInput: true,
    altFormat: "J F Y",
  });

  function updateMediaTierOptions() {
    let selectedTier = $("#client-report-tier-select").val();
    let campaignId = $(".client-report-campaign-select").val();
    let mediaTierSelect = $("#client-report-media-tiers-select");
    let currentSelections = (mediaTierSelect.val() || []).map(function (id) {
      return String(id);
    });

    mediaTierSelect.empty();

    if (!selectedTier) {
      mediaTierSelect.prop("disabled", true);
      mediaTierSelect.val(null);
      mediaTierSelect.trigger("change");
      initialSelectedMediaTierIds = [];
      return;
    }

    let params = { tier_filter: selectedTier };

    if (campaignId) {
      params.campaign_id = campaignId;
    }

    $.getJSON(props.media_tiers_url, params, function (data) {
      let optionIds = [];

      data.forEach(function (mediaTier) {
        let mediaTierId = String(mediaTier.id);
        optionIds.push(mediaTierId);
        mediaTierSelect.append(
          new Option(mediaTier.name, mediaTierId, false, false),
        );
      });

      let selectionsToKeep = [];

      if (currentSelections.length > 0) {
        selectionsToKeep = currentSelections.filter(function (id) {
          return optionIds.includes(id);
        });
      } else if (initialSelectedMediaTierIds.length > 0) {
        selectionsToKeep = initialSelectedMediaTierIds.filter(function (id) {
          return optionIds.includes(id);
        });
      }

      mediaTierSelect.prop("disabled", optionIds.length === 0);
      mediaTierSelect.val(selectionsToKeep);
      mediaTierSelect.trigger("change");
      initialSelectedMediaTierIds = [];
    });
  }

  function updateMediaTiersTable(campaignId) {
    let url = props.media_tier_guide_url;

    if (campaignId) {
      url = url + "?campaign_id=" + campaignId;
    }

    $.get(url, function (result) {
      $(".media-tier-guide").html(result);
    });
  }

  function onCampaignChange() {
    let campaignId = $(".client-report-campaign-select").val();
    updateMediaTiersTable(campaignId);
    updateMediaTierOptions();
  }

  $("#client-report-tier-select").on("change", updateMediaTierOptions);
  $(".client-report-campaign-select").on("change", onCampaignChange);
  updateMediaTiersTable($(".client-report-campaign-select").val());
  updateMediaTierOptions();

  function destroy() {
    $("#client-report-tier-select").off("change", updateMediaTierOptions);
    $(".client-report-campaign-select").off("change", onCampaignChange);
    select2MediaTiers.select2("destroy");
    periodStartInstance.destroy();
    periodEndInstance.destroy();
  }

  return {
    destroy: destroy,
  };
}
